import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `${token}`,
    }
  };
};

export const createLandlord = async (data) => {
  const response = await api.post('/create-landlord', data);
  return response.data;
};
